import { render, staticRenderFns } from "./NewWebsiteForm.vue?vue&type=template&id=2ab83c0a&"
import script from "./NewWebsiteForm.vue?vue&type=script&lang=ts&"
export * from "./NewWebsiteForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports